export default __webpack_public_path__ + "static/media/comparable-empty-results.81a7beb3.svg";